import React, {useState} from 'react';

import {Calendar} from "../../../../core/icons/calendar";
import {DatePickerProps} from "../../../../core/components/date-picker/date-picker";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {DeviceViewModel} from "../../../../core/models/device.view-model";
import {BaseLinkModel} from "../../../../infrastructure/models/link/base-link-model";
import {Button} from "../../../../core/components/misc/buttons/button";
import {ScrollBlocker} from "../../../../core/components/misc/blockers/scroll-blocker";
import {DatePickerTooltip} from "../../../../core/components/date-picker/date-picker.tooltip";

export class ScoresHeaderModuleMobileDatePickerComponentProps extends BaseProps {
  selectedDate: Date;
  linkType: BaseLinkModel;
  device: DeviceViewModel;
}

export const ScoresListHeaderModuleMobileDatePicker = (props: ScoresHeaderModuleMobileDatePickerComponentProps) => {
  const [open, setOpen] = useState(false);

  const pickerProps: DatePickerProps = {
    controller: props.controller,
    linkType: props.linkType,
    selectedDate: props.selectedDate,
    onDateChange: props.onDateChange,
    onChange: () => {
      setOpen(false);
    }
  };

  const pickerBackgroundProps = {
    onDisable: () => setOpen(false),
    blanket: true,
    blockScrolling: true,
  };

  const calenderContainerProps = {
    onClick: () => setOpen(!open)
  };

  return (
    <>
      <DatePickerTooltip {...pickerProps}>
        <Button {...calenderContainerProps}>
          <Calendar active={open}/>
        </Button>
      </DatePickerTooltip>
      {
        open && <ScrollBlocker {...pickerBackgroundProps}/>
      }
    </>
  );
};
